import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { fetchArticleCash, updateArticleCash, setArticleCashEdit, fetchArticlesCashCategories } from '../../action/handbook';
import cn from 'classnames';
import Loader from '../utils/Loader';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';
import Select from 'react-select';
import { optionsMovementCash, optionsTransaction } from '../../constants/app';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class EditArticleCash extends Component {
    componentWillUnmount() {
        this.props.setArticleCashEdit(null);
    }

    componentDidMount() {
        this.props.fetchArticleCash(this.props.match.params.id).then(article => {
            this.props.setArticleCashEdit(article);
        });
        this.props.setUIvisible(false, false);
        this.props.fetchArticlesCashCategories();
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">{this.props.edit.name ? this.props.edit.name : 'Введите название статьи *'}</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/articlesCash')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValidArticleCash() {
        const { name, typeTransaction, typeMovementCash, category } = this.props.edit;
        if (name && typeTransaction && typeMovementCash && category) return true;
        
        return false;
    }

    setArticleCash = (field) => (e) => {
            const data = {...this.props.edit};
            if(field === 'name') {
                data[field] = e.target.value;
            } else {
                data[field] = e.value;
            }

            // if(field === 'typeMovementCash' && e.value === 'incasso') {
            //     data.typeTransaction = 'cash';
            // }

            this.props.setArticleCashEdit(data);
        }

    onSubmit = (e) => {
        e.preventDefault();
        const edited = { ...this.props.edit };
        this.props.updateArticleCash(this.props.match.params.id, edited).then(result => {
            if (result) {
                this.props.history.push('/handbook/articlesCash');
            }
        });        
    }

    getCategoryValue = () => {
        const categortId = this.props.edit.category ? this.props.edit.category.id ? this.props.edit.category.id : this.props.edit.category : null;
        if (!categortId) return null;
        const entity = this.props.articlesCashCategories.find((item) => item.id === categortId);
        if (!entity) return null;
        return { value: entity.id, label: entity.name };
    }

    render() {
        const { loading, edit } = this.props;
        if (loading || !edit) {
            return (
                <div style={styles.loading}><Loader/></div>
            );
        }

        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <form onSubmit={this.onSubmit} className="kt-form">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body">
                            <div className="row">
                                <div className="col-md-4">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setArticleCash('name')}
                                        value={edit.name}
                                        placeholder="Название..."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>{"Тип транзакции *"}</label>
                                    <Select
                                        isDisabled={edit.typeMovementCash === 'incasso'}
                                        closeMenuOnSelect={true}
                                        value={optionsTransaction.find((option) => option.value === edit.typeTransaction)}
                                        onChange={this.setArticleCash('typeTransaction')}
                                        placeholder="Тип транзакции"
                                        options={optionsTransaction}
                                        noOptionsMessage={() => 'Нет типов'}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>{"Тип *"}</label>
                                    <Select
                                        closeMenuOnSelect={true}
                                        value={optionsMovementCash.find((option) => option.value === edit.typeMovementCash)}
                                        onChange={this.setArticleCash('typeMovementCash')}
                                        placeholder="Тип"
                                        options={optionsMovementCash.filter((option) => !option.notRender)}
                                        noOptionsMessage={() => 'Нет типов'}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label>{"Категория *"}</label>
                                    <Select
                                        isLoading={this.props.loading}
                                        closeMenuOnSelect={true}
                                        value={this.getCategoryValue()}
                                        onChange={this.setArticleCash('category')}
                                        placeholder="Категория"
                                        options={this.props.articlesCashCategories.map((item) => ({ value: item.id, label: item.name}))}
                                        noOptionsMessage={() => 'Нет категорий'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet">
                        <ErrorContainer field="editArticleCash" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValidArticleCash() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.editArticleCashLoader })}>
                                    Сохранить
                                </button>
                            </div>
                        </div>                    
                    </div>
                </form>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    articlesCashCategories: state.handbook.articlesCashCategories,
    edit: state.handbook.articleCash.edit,
    loading: state.loaders.articleCash || state.loaders.articlesCashCategories,
    editArticleCashLoader: state.loaders.editArticleCash
});

const mapDispatchToProps = {
    setArticleCashEdit: (data) => setArticleCashEdit(data),
    fetchArticleCash: (id) => fetchArticleCash(id),
    updateArticleCash: (id, data) => updateArticleCash(id, data),
    fetchArticlesCashCategories: () => fetchArticlesCashCategories(true),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditArticleCash);